/* eslint-disable react/jsx-filename-extension */
import { ACTIVE_STATUS, ENDED_STATUS } from '../components/Pages/Champion/ChampionChecker/ChampionOwner/statusMapper';
import hordBanner from '../images/hpool-banner.png';
import { claimMyTokens } from '../services/createHPoolService';
import {
  hpoolCheckChampionDepositRefund,
  hpoolGetUserSubscriptionForPool,
  hpoolRefundChampionOnFail,
  hpoolWithdrawDepositReq,
} from '../services/hpoolService';
import { claimVpoolTokens, vpoolRefundChampionOnFail } from '../services/vpoolService';

export const POOL_INFO_TAGS = [
  { value: 'nft', label: '#NFT' },
  { value: 'stable', label: '#Stable' },
  { value: 'defi', label: '#DeFi' },
];

export const CHART_TABS = [
  { value: 'nft', label: '#NFT' },
  { value: 'stable', label: '#Stable' },
  { value: 'defi', label: '#DeFi' },
];

export const SOCIAL_MEDIA_BTNS = [
  { label: 'Email', color: '#A5A5A5', name: 'mail' },
  { label: 'Twitter', color: '#1DA1F2', name: 'twitter' },
  { label: 'Reddit', color: '#ff4500', name: 'mail' },
  { label: 'Facebook', color: '#1773EA', name: 'mail' },
  { label: 'Telegram', color: '#24AAEC', name: 'mail' },
  { label: 'Whatsapp', color: '#24D637', name: 'mail' },
];

export const DISABLED_UPDATE_LISTENER_STATUSES = [ENDED_STATUS, ACTIVE_STATUS];

export const EDIT_TOKEN_VIEW_STAGE = 1;
export const CONFIRM_TOKENS_CHANGES_STAGE = 2;
export const UPDATED_HPOOL_LIST_STAGE = 3;
export const EDIT_ORDER_DETAILS_STAGE_INDEX = -1;

export const hpoolInfoSrc = {
  contractName: 'HordHPoolManager',
  configContract: 'HordConfiguration',
  poolInfoMethod: 'hPool',
  headerBanner: hordBanner,
  userTabs: [
    { id: 'subscription_data' },
    { id: 'tx_history' },
    { id: 'tickets_and_staking' },
    { id: 'closed_positions' },
  ],
  newOrderTabs: [
    { id: 'buyLimit', title: 'Buy Limit' },
    { id: 'sellLimit', title: 'Sell Limit' },
    { id: 'stopLoss', title: 'Stop Loss' },
  ],
  openOrderTabs: [
    { id: '', title: 'All' },
    { id: 'BUY_LIMIT', title: 'Limit Buy' },
    { id: 'SELL_LIMIT', title: 'Limit Sell' },
    { id: 'STOP_LOSS', title: 'StopLoss' },
  ],
  claimPoolTokensMethod: claimMyTokens,
  checkChampionDepositRefund: hpoolCheckChampionDepositRefund,
  refundChampion: hpoolRefundChampionOnFail,
  refundUser: hpoolWithdrawDepositReq,
  getUserSubscriptionForPool: hpoolGetUserSubscriptionForPool,
  subscribtionMethodInput: (hpool) => [
    'HordHpoolManager',
    ['privateSubscribeForHPool', 'publicSubscribeForHPool'],
    hpool.web3_hpool_id,
  ],
  subscribtionAbi: [
    {
      internalType: 'uint256',
      name: 'poolId',
      type: 'uint256',
    },
  ],
  isPoolCreationPayable: true,
};

export const TOKENS_REQUIRE_ALLOWNCE = ['busd', 'hord'];
